import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { PromotionBoosterLinkableType, useMixins } from '@/modules/promotion/booster/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function usePromotionBoosterDetail() {
    const router = useAppRouter();
    const route = useRoute();

    const { fetchLinkableItems, getItemName, getItemLink } = useMixins();

    const model = reactive({
        id: route.params?.id || null,
        name: null,
        promotionId: null,
        boosters: [],

        get promotionName() {
            return getItemName(PromotionBoosterLinkableType.PromotionItem, this.promotionId);
        },
        get promotionLink() {
            return getItemLink(PromotionBoosterLinkableType.PromotionItem, this.promotionId);
        }
    });

    const fetch = useCrudActions().executeAction({
        canExecute: () => model.id != null,
        request: () => promotionService.booster.get(model.id),
        onSuccess: ({ data }) => {
            model.name = data.name;
            model.promotionId = data.promotionId;
            model.boosters = data.boosters.map((booster: any) => ({
                ...booster,
                name: getItemName(PromotionBoosterLinkableType.BoosterItem, booster.type),
                link: getItemLink(PromotionBoosterLinkableType.BoosterItem, booster.type)
            }));
        },
        onError: () => router.push({ name: ROUTE_NAME_PROMOTION.BOOSTER.INDEX })
    });

    onMounted(async () => {
        await fetchLinkableItems();
        await fetch();
    });

    return { model };
}
